import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface SectionHeaderProps {
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    variant?: 'default' | 'secondary' | 'outline';
  };
  className?: string;
  children?: React.ReactNode;
}

export function SectionHeader({
  title,
  description,
  action,
  className,
  children,
}: SectionHeaderProps) {
  return (
    <div className={cn('space-y-4 mb-6', className)}>
      {/* Title and Description Section */}
      <div className="space-y-2">
        <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-gray-900 dark:text-gray-100 leading-tight">
          {title}
        </h1>
        {description && (
          <p className="text-sm sm:text-base text-gray-600 dark:text-gray-400 leading-relaxed max-w-4xl">
            {description}
          </p>
        )}
      </div>

      {/* Action Section */}
      {(children || action) && (
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 pt-2">
          <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto">{children}</div>
          {action && (
            <Button
              onClick={action.onClick}
              variant={action.variant || 'default'}
              className="w-full sm:w-auto flex-shrink-0"
            >
              {action.label}
            </Button>
          )}
        </div>
      )}
    </div>
  );
}
